export const fixedCards: string[] = [
  'Declaração de inexistência de outros seguros',
  'Cartão CNPJ',
  'Comprovante de endereço do local',
  'Dados bancários',
];
